import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type ShellAccountMenuTriggerProps = PropsWithChildren<{
  isOpen: boolean;
  onClick(): void;
  className?: string;
}>;

export default function ShellAccountMenuTrigger({
  isOpen,
  onClick,
  className,
  children,
}: ShellAccountMenuTriggerProps) {
  const { t } = useTranslation('translation', { keyPrefix: 'appShell' });

  return (
    <button
      type="button"
      aria-label={t('openAccountMenu')}
      aria-haspopup="dialog"
      aria-expanded={isOpen}
      className={twMerge('flex items-center gap-2 overflow-hidden', className)}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
